import React, { useState, useContext, useEffect } from 'react';
import '../agent_page.css'
import { AppContext } from '../../../provider.jsx'
import { getPaymentRequestDocument, verifyPaymentRequest, rejectPaymentRequest } from '../../../homepage/homepage_logic.js';
import { showPaymentRequestDocument } from '../../../controller/agent_data_controller.js';

export const PaymentDetailsVerify = ({ currentItem, callback }) => {
    const { setPageIndex } = useContext(AppContext);
    const [loading, setLoading] = useState(true);
    const [documents, setDocumnets] = useState([]);
    const [status, setStatus] = useState('');
    const [actionLoading, setActionLoading] = useState(false);

    // Reject modal state
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [rejectReason, setRejectReason] = useState('');

    useEffect(() => {
        setStatus(currentItem[8])
        const fetchData = async () => {
            try {
                let result = await getPaymentRequestDocument(currentItem[0]);
                if (result) {
                    setDocumnets(result);
                } else {
                    setDocumnets([[0, 'none']]);
                    alert('Cannot fetch documents');
                }
            } catch (err) {
                console.error("Error fetching:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, []);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'Approved': return { color: '#155724', backgroundColor: '#d4edda' };
            case 'Pending': return { color: '#856404', backgroundColor: '#fff3cd' };
            case 'Rejected': return { color: '#721c24', backgroundColor: '#f8d7da' };
            default: return { color: 'gray', backgroundColor: '#e9ecef' };
        }
    };

    const formatAmount = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount);
    };

    const handleApprove = async () => {
        setActionLoading(true);
        const response = await verifyPaymentRequest(currentItem[0], 'Approved by admin');
        if (response === 'success') {
            setStatus('Approved');
            alert('Payment Request Approved Successfully. Agent balance has been credited.');
            callback();
        } else {
            alert('Unable to approve request: ' + response);
        }
        setActionLoading(false);
    };

    const handleReject = async () => {
        if (!rejectReason.trim()) {
            alert('Please enter a reason for rejection.');
            return;
        }
        setActionLoading(true);
        const response = await rejectPaymentRequest(currentItem[0], rejectReason.trim());
        if (response === 'success') {
            setStatus('Rejected');
            setShowRejectModal(false);
            alert('Payment Request Rejected. Agent has been notified by email.');
            callback();
        } else {
            alert('Unable to reject request: ' + response);
        }
        setActionLoading(false);
    };

    if (!currentItem) {
        return <div>No payment data available</div>;
    }
    if (loading) return <p>Loading...</p>;

    return (
        <div>
            {/* Reject Reason Modal */}
            {showRejectModal && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0,0,0,0.4)', display: 'flex', alignItems: 'center',
                    justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '30px',
                        width: '420px', boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
                    }}>
                        <p style={{ fontSize: '18px', fontWeight: '600', marginBottom: '8px', color: '#333' }}>
                            Reject Payment Request
                        </p>
                        <p style={{ fontSize: '14px', color: '#666', marginBottom: '16px' }}>
                            Please provide a reason for rejection. The agent will be notified by email.
                        </p>
                        <textarea
                            value={rejectReason}
                            onChange={(e) => setRejectReason(e.target.value)}
                            placeholder="Enter reason for rejection..."
                            style={{
                                width: '100%', minHeight: '100px', padding: '10px 14px',
                                borderRadius: '8px', border: '1px solid #ccc', fontSize: '14px',
                                fontFamily: 'Roboto, sans-serif', resize: 'vertical', boxSizing: 'border-box',
                                outline: 'none'
                            }}
                        />
                        <div style={{ display: 'flex', gap: '12px', marginTop: '16px' }}>
                            <button
                                onClick={handleReject}
                                disabled={actionLoading}
                                style={{
                                    flex: 1, padding: '10px', borderRadius: '8px', border: 'none',
                                    backgroundColor: '#dc3545', color: 'white', fontSize: '15px',
                                    fontWeight: '500', cursor: actionLoading ? 'not-allowed' : 'pointer',
                                    opacity: actionLoading ? 0.7 : 1
                                }}
                            >
                                {actionLoading ? 'Rejecting...' : 'Confirm Reject'}
                            </button>
                            <button
                                onClick={() => { setShowRejectModal(false); setRejectReason(''); }}
                                disabled={actionLoading}
                                style={{
                                    flex: 1, padding: '10px', borderRadius: '8px',
                                    border: '1px solid #ccc', backgroundColor: 'white',
                                    fontSize: '15px', fontWeight: '500', cursor: 'pointer'
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <div style={{ display: 'flex', alignItems: 'center', margin: '30px 50px 17px 42px', justifyContent: 'space-between' }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    <div onClick={() => { setPageIndex(0) }} className='submit-button-variable' style={{ marginRight: '30px' }}>
                        <span>🡐 Back</span>
                    </div>
                    <p className='title-demo' style={{ margin: '0' }}>Payment Details</p>
                </div>
            </div>

            <div style={{ width: '100%', minHeight: '80%', display: 'flex', justifyContent: 'center' }}>
                <div className='content-div-demo' style={{ padding: '20px' }}>

                    {/* Header with action buttons */}
                    <div style={{ borderBottom: '1px solid #eee', padding: '10px 20px 16px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <p style={{ fontSize: '20px', fontWeight: '600', margin: 0 }}>Payment Information</p>
                        {status === 'Pending' && (
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button
                                    onClick={handleApprove}
                                    disabled={actionLoading}
                                    style={{
                                        padding: '8px 20px', borderRadius: '8px', border: 'none',
                                        backgroundColor: '#28a745', color: 'white', fontSize: '14px',
                                        fontWeight: '500', cursor: actionLoading ? 'not-allowed' : 'pointer',
                                        opacity: actionLoading ? 0.7 : 1
                                    }}
                                >
                                    {actionLoading ? 'Processing...' : '✓ Approve'}
                                </button>
                                <button
                                    onClick={() => setShowRejectModal(true)}
                                    disabled={actionLoading}
                                    style={{
                                        padding: '8px 20px', borderRadius: '8px', border: 'none',
                                        backgroundColor: '#dc3545', color: 'white', fontSize: '14px',
                                        fontWeight: '500', cursor: actionLoading ? 'not-allowed' : 'pointer',
                                        opacity: actionLoading ? 0.7 : 1
                                    }}
                                >
                                    ✕ Reject
                                </button>
                            </div>
                        )}
                        {status !== 'Pending' && (
                            <span style={{
                                padding: '6px 14px', borderRadius: '6px', fontSize: '13px',
                                fontWeight: '500', ...getStatusColor(status)
                            }}>
                                {status}
                            </span>
                        )}
                    </div>

                    {/* Row 1: Name - Payment Method */}
                    <div style={{ display: 'flex', gap: '40px', padding: '20px 0 10px 20px' }}>
                        <div style={{ flex: 1 }}>
                            <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Name</p>
                            <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{currentItem[1]}</p>
                        </div>
                        <div style={{ flex: 1 }}>
                            <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Payment Method</p>
                            <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{currentItem[3]}</p>
                        </div>
                    </div>

                    {/* Row 2: Bank/UPI - Amount */}
                    <div style={{ display: 'flex', gap: '40px', padding: '20px 0 10px 20px' }}>
                        <div style={{ flex: 1 }}>
                            {currentItem[3] === 'Bank Transfer' ? (
                                <div>
                                    <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Bank Name</p>
                                    <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{currentItem[4]}</p>
                                </div>
                            ) : (
                                <div>
                                    <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>UPI ID</p>
                                    <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{currentItem[7]}</p>
                                </div>
                            )}
                        </div>
                        <div style={{ flex: 1 }}>
                            <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Amount</p>
                            <p style={{ fontSize: '18px', fontWeight: '600', margin: 0, color: '#28a745' }}>{formatAmount(currentItem[2])}</p>
                        </div>
                    </div>

                    {/* Row 3: Date - Status */}
                    <div style={{ display: 'flex', gap: '40px', padding: '20px 0 10px 20px' }}>
                        <div style={{ flex: 1 }}>
                            <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Date</p>
                            <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{formatDate(currentItem[10])}</p>
                        </div>
                        <div style={{ flex: 1 }}>
                            <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Status</p>
                            <span style={{
                                display: 'inline-block', padding: '4px 10px', borderRadius: '6px',
                                fontSize: '13px', fontWeight: '500', ...getStatusColor(status)
                            }}>
                                {status}
                            </span>
                        </div>
                    </div>

                    {/* Row 4: Account + IFSC for Bank Transfer */}
                    {currentItem[3] === 'Bank Transfer' && (
                        <div style={{ display: 'flex', gap: '40px', padding: '20px 0 10px 20px' }}>
                            <div style={{ flex: 1 }}>
                                <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Account Number</p>
                                <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{currentItem[5]}</p>
                            </div>
                            <div style={{ flex: 1 }}>
                                <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>IFSC Code</p>
                                <p style={{ fontSize: '18px', fontWeight: '600', margin: 0 }}>{currentItem[6]}</p>
                            </div>
                        </div>
                    )}

                    {/* Rejection reason (shown after rejection) */}
                    {status === 'Rejected' && currentItem[9] && (
                        <div style={{ padding: '20px 0 10px 20px' }}>
                            <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Rejection Reason</p>
                            <div style={{ backgroundColor: '#fff3f3', border: '1px solid #f5c6cb', borderRadius: '8px', padding: '12px 16px' }}>
                                <p style={{ fontSize: '15px', color: '#721c24', margin: 0 }}>{currentItem[9]}</p>
                            </div>
                        </div>
                    )}

                    {/* Payment Receipt document */}
                    <div style={{ padding: '20px 0 10px 20px' }}>
                        <p style={{ fontSize: '13px', color: '#888', paddingBottom: '6px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Payment Receipt</p>
                        <p style={{ fontSize: '15px', fontWeight: '600', margin: '0 0 8px 0' }}>{documents[0]?.[1] || 'No document'}</p>
                        {documents[0]?.[0] > 0 && (
                            <div
                                onClick={() => showPaymentRequestDocument(documents[0][0])}
                                className='view-button'
                                style={{ marginTop: '8px', display: 'inline-block' }}
                            >
                                📄 View Document
                            </div>
                        )}
                    </div>

                    <div style={{ height: '20px' }} />
                </div>
            </div>
        </div>
    )
}
